import repository from './repsitory'

const resource = '/card'

export default {
    get () {
        return repository.get(`${resource}`)
    },
    getCardsMtg () {
        return repository.get(`${resource}/GetCardsMtg`)
    },
    getCardsPokemon () {
        return repository.get(`${resource}/GetCardsPokemon`)
    },
    getCardsYugi () {
        return repository.get(`${resource}/GetCardsYugi`)
    },
    getById (id) {
        return repository.get(`${resource}/${id}`)
    },
    addCard (data) {
        return repository.post(`${resource}`, data)
    },
    updateCard (data, id) {
        return repository.put(`${resource}/${id}`, data)
    },
     getCardsFiltered (data) {
        return repository.post(`${resource}/filter`, data)
    },
}
